/**
 * Helpers compartidos de invitaciones F&F para las vistas de backoffice.
 * Asume que la vista tiene `iso`, `i18n`, `$buefy` y `getProfile()`.
 */
import axios from "axios";
import moment from "moment";
import {
  resolveFFInvitationStatus,
  ffInvitationLabelKey,
  ffInvitationBadgeType,
  canResendInvitation,
  canRevokeInvitation,
} from "../utils/ffInvitation";

const API_URL = process.env.VUE_APP_API_URL;

export default {
  data() {
    return {
      ffAgeModal: { active: false, names: [], index: null, loading: false },
    };
  },
  methods: {
    ffStatus(ff) {
      return resolveFFInvitationStatus(ff);
    },
    ffStatusLabel(status) {
      return ffInvitationLabelKey(status);
    },
    ffStatusBadge(status) {
      return ffInvitationBadgeType(status);
    },
    ffCanResend(ff) {
      return canResendInvitation(ff);
    },
    ffCanRevoke(ff) {
      return canRevokeInvitation(ff);
    },
    formatFFDate(value) {
      return value ? moment(value).format("DD/MM/YYYY") : "";
    },
    cancelFFAgeWarning() {
      if (this.ffAgeModal.loading) return;
      this.ffAgeModal = { active: false, names: [], index: null, loading: false };
    },
    openFFAgeWarning(idx, ff) {
      const name = `${ff?.Nombre || ""} ${ff?.ApellidoPaterno || ""}`.trim();
      this.ffAgeModal = {
        active: true,
        names: [name || "Friends & Family"],
        index: idx,
        loading: false,
      };
    },
    async resendFFInvitation(ff) {
      this.$buefy.dialog.confirm({
        title: this.i18n.friendsFamily__resendInvitation[this.iso],
        message: this.i18n.friendsFamily__resendConfirm[this.iso],
        confirmText: this.i18n.friendsFamily__resendInvitation[this.iso],
        cancelText: this.i18n.friendsFamily__ageWarningCancel[this.iso],
        type: "is-info",
        onConfirm: async () => {
          try {
            await axios.post(
              `${API_URL}/catcher/members/${ff._id}/ff-invitation/resend`
            );
            await this.getProfile();
            this.$buefy.toast.open({
              message: this.i18n.friendsFamily__resendOk[this.iso],
              type: "is-success",
            });
          } catch (error) {
            this.$buefy.toast.open({
              message:
                error?.response?.data?.message ||
                this.i18n.friendsFamily__invitationError[this.iso],
              type: "is-danger",
            });
          }
        },
      });
    },
    async revokeFFInvitation(ff) {
      this.$buefy.dialog.confirm({
        title: this.i18n.friendsFamily__revokeInvitation[this.iso],
        message: this.i18n.friendsFamily__revokeConfirm[this.iso],
        confirmText: this.i18n.friendsFamily__revokeInvitation[this.iso],
        cancelText: this.i18n.friendsFamily__ageWarningCancel[this.iso],
        type: "is-danger",
        onConfirm: async () => {
          try {
            await axios.post(
              `${API_URL}/catcher/members/${ff._id}/ff-invitation/revoke`
            );
            await this.getProfile();
            this.$buefy.toast.open({
              message: this.i18n.friendsFamily__revokeOk[this.iso],
              type: "is-success",
            });
          } catch (error) {
            this.$buefy.toast.open({
              message:
                error?.response?.data?.message ||
                this.i18n.friendsFamily__invitationError[this.iso],
              type: "is-danger",
            });
          }
        },
      });
    },
  },
};
